/* Internet banking gateways, routing and TDR.
 *
 * Extracted verbatim from src/App.script.js. Behaviour is unchanged;
 * these methods run on the App instance exactly as before.
 */
import axios from "axios";

export default {
  methods: {

    /**
     * Ibanking Payment
     * 1)With TDR
     * 2)Without TDR
     */

    tdrComissionInfoIBanking(card_name, store_id, gateway_id, gateway_type_id) {
      var sp_token = this.$route.query.token;
      var amount = this.sp_amount;
      const options = {
        method: "POST",
        url: this.base_url + "v1/landing/surcharge",
        headers: {
          Authorization: "Bearer " + sp_token,
        },
        data: { amount, store_id, gateway_id },
      };
      axios
        .request(options)
        .then((response) => {
          var isSurchargeEnable = response.data.isSuccess;

          if (
            isSurchargeEnable === true &&
            response.data.response.isSurcharge === true
          ) {
            this.additional_fees_amt = response.data.response.commSurcharge;
            this.payable_amt = response.data.response.debitAmount;

            this.tdr_visibility = this.is_add_commission;
            this.tdr_visibility_pay_now_btn = this.is_add_commission;
            this.normal_user = 0;

            this.gateway_type_id_tdr = gateway_type_id;
            this.card_name_tdr = card_name;
          } else {
            this.tdr_visibility = 0;
            this.tdr_visibility_pay_now_btn = 0;
            this.normal_user = 1;
            this.payable_amt = 0;
            this.gateway_type_id_tdr = gateway_type_id;
            this.goDirectIBankingGateway(card_name);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //token implemented
    go_ibanking_gateway(card_name, gateway_id, gateway_type_id) {
      this.ibanking_selected_gateway_iddd = gateway_id;
      this.sp_orderid = this.$route.query.order_id;
      this.sp_token = this.$route.query.token;

      if (typeof this.sp_token === "undefined") {
        this.isMainDiv = false;
        this.isUnauthorized = true;
        this.isMaintenanceMode = false;
      } else {
        const options = {
          method: "POST",
          url: this.base_url + "check-token",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.AssignIBankingGatway(card_name, gateway_id, gateway_type_id);
            } else if (response.data.sp_code == "1064") {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          });
      }
    },

    AssignIBankingGatway(card_name, gateway_id, gateway_type_id) {
      var store_id = this.store_id;
      var is_add_commission_tdr = this.is_add_commission;

      if (is_add_commission_tdr == 1) {
        //console.log("is_add_commission enabled");
        this.tdrComissionInfoIBanking(
          card_name,
          store_id,
          gateway_id,
          gateway_type_id
        );
      } else {
        //console.log("No is_add_commission enabled");
        this.goDirectIBankingGateway(card_name);
      }
    },

    goDirectIBankingGateway(card_name) {
      if (card_name === "") {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 6000;
        this.popup_text = "No card name is found.";
      }

      if (card_name !== "") {
        var payable_amount2 = this.payable_amt;
        var amount;

        if (payable_amount2 > 0) {
          amount = payable_amount2;
        } else {
          amount = this.sp_amount;
        }

        if (amount < 10) {
          this.snackbar = true;
          this.color = "red";
          this.timeout = 3000;
          this.popup_text = "Amount Cannot be less than 10 Taka.";
        } else {
          this.loading_tab = true;
          this.loading_dialog = true;
          var store_id = this.store_id;
          var orderid = this.$route.query.order_id;
          var emi_str = this.editedItem.emi;
          var wordpos = emi_str.search("months");
          var emi_month = emi_str.substring(0, wordpos - 1);
          var emi_amt = emi_str.substring(wordpos + 7, emi_str.length);
          var sp_token = this.$route.query.token;
          var invoiceno = this.invoiceno;
          const options = {
            method: "POST",
            url: this.base_url + "only-card-pay",
            headers: {
              Authorization: "Bearer " + sp_token,
            },
            data: {
              card_name,
              store_id,
              orderid,
              emi_month,
              emi_amt,
              invoiceno,
            },
          };
          axios
            .request(options)
            .then((response) => {
              if (response.data.message == 1) {
                this.loading_tab = false;
                this.loading_dialog = false;
                window.location.href = response.data.url;
              } else if (response.data.message == 5) {
                document.open();
                document.write(response.data.url);         // HTML display
                document.close();
              } else {
                this.loading_tab = false;
                this.loading_dialog = false;
                this.snackbar = true;
                this.color = "red";
                this.timeout = 3000;
                this.popup_text = "Something went wrong";
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },

    //checked when clicked
    show_ibanking() {
      this.card_tab = false;
      this.mobile_banking = false;
      this.i_banking = true;
      this.user_account = false;
      this.loading_tab = false;
      this.loading_dialog = false;
      this.saved_card_tab1 = false;
      var passStoreID = this.store_id;

      this.tdr_visibility = 0;
      this.tdr_visibility_pay_now_btn = 0;
      this.normal_user = 1;
      this.payable_amt = 0;
      this.cof_pay_now_btn_label = "Pay Now";
      this.saved_card_paynow_label = "Pay Now";
      this.isFormValid2 = false;
      this.selectedCvvIndex = null;

      this.merchant_gateway(3);

      this.cards_selected_gateway_iddd = 0;
      this.mfs_selected_gateway_iddd = 0;
      this.ibanking_selected_gateway_iddd = 0;
      this.saved_card_list = false;
      this.deleteCardConfirmationDialog = false;
      this.deleteConfirmationCard = false;
      this.cardSkeletonLoader = false;
      this.AccountActiveDeactiveDiv = false;
    },
  },
};
